<sigv-data-table
  #dataTable
  [(value)]="files"
  [columns]="fileColumns"
  [(selection)]="selectedFiles"
  [selectable]="!readonly"
  [editable]="!readonly"
  [canDelete]="!readonly"
  dataKey="id"
  [displayRowChkboxFunc]="displayRowChkboxFunc"
  [displayRowEditBtnFunc]="displayRowEditBtnFunc"
  [reorderableColumns]="false"
  [validateRowDeleteFunc]="pageActions.onRowDelete"
  [validateRowEditFunc]="pageActionas.onRowEditValidate"
  (validateDeleteFailMsg)="onRowDeleteMsg($event)"
  (valueChange)="onValueChange($event)"
  (rowEditSave)="onRowEditSave($event)"
>
  <ng-template pTemplate="toolbar">
    <label
      *ngIf="selectedFiles.length === 0 && !readonly"
      pButton
      type="button"
      label="{{ 'Upload' | translate }}"
      icon="pi pi-cust-upload"
      class="p-button-action p-button-outlined p-content-button mr-10"
    >
      <input
        #fileInput
        type="file"
        style="display: none"
        multiple
        [accept]="acceptTypes"
        (change)="
          onUploadBtnClick($event, pageData.selectLists.documentTypeOptions)
        "
      />
    </label>
    <ng-container *ngIf="toolbarTemplate">
      <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
    </ng-container>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-fileInfo
    let-rowIndex="rowIndex"
    let-editing="editing"
    let-columns="columns"
  >
    <ng-container *ngIf="readonly; else tableRow">
      <tr>
        <ng-container *ngTemplateOutlet="tableRow"></ng-container>
      </tr>
    </ng-container>
    <ng-template #tableRow>
      <ng-container *ngFor="let col of columns">
        <td [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'fileId'">
            <i
              *ngIf="checkIsShowFileTypeIcon(fileInfo); else showUnknow"
              [ngClass]="getFileTypeIconStyleClassName(fileInfo)"
            ></i>
            <ng-template #showUnknow>
              <i
                *ngIf="!checkIsPhoto(fileInfo); else showImage"
                class="icon-unknow"
              ></i>
            </ng-template>
            <ng-template #showImage>
              <div *ngIf="fileInfo.fileId != undefined">
                <img
                  [src]="getFileUrl(fileInfo.fileId) | imageUrl | async"
                  alt="photo"
                  style="max-width: 60px; max-height: 60px"
                  (click)="onRowImageClick(fileInfo)"
                />
              </div>
              <div *ngIf="fileInfo.fileId == undefined">
                <img
                  [src]="fileInfo.url | imageUrl | async"
                  alt="photo"
                  style="max-width: 60px; max-height: 60px"
                  (click)="onRowImageClick(fileInfo)"
                />
              </div>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'documentType'">
            <ng-container
              *ngIf="!documentTypeBySubKey; else documentTypeBySubKeyTemplate"
            >
              <ng-container *ngIf="editing; else documentTypeReadonly">
                <p-dropdown
                  *ngIf="useInCase"
                  sigvDropdownSetting
                  [options]="pageData.selectLists.documentTypeOptions"
                  [(ngModel)]="fileInfo.documentType"
                  panelStyleClass="table-dropdown"
                  appendTo="body"
                  [style]="{ width: '100%' }"
                  (ngModelChange)="onFileInfoChange(fileInfo)"
                >
                  <ng-template pTemplate="item" let-item>
                    {{ item.label | translate }}
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-item>
                    {{ item.label | translate }}
                  </ng-template>
                </p-dropdown>
              </ng-container>
              <ng-template #documentTypeReadonly>
                {{
                  fileInfo.documentType
                    | optionsMapping : pageData.selectLists.documentTypeOptions
                    | replaceNullWith : '-'
                }}
              </ng-template>
            </ng-container>
            <ng-template #documentTypeBySubKeyTemplate>
              <ng-container *ngIf="editing; else documentTypeBySubKeyReadonly">
                <p-dropdown
                  *ngIf="useInCase"
                  sigvDropdownSetting
                  [options]="util.getSelectionOptionsBySubKey(fileInfo)"
                  [(ngModel)]="fileInfo.documentType"
                  panelStyleClass="table-dropdown"
                  appendTo="body"
                  [style]="{ width: '100%' }"
                  (ngModelChange)="onFileInfoChange(fileInfo)"
                >
                  <ng-template pTemplate="item" let-item>
                    {{ item.label | translate }}
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-item>
                    {{ item.label | translate }}
                  </ng-template>
                </p-dropdown>
              </ng-container>
              <ng-template #documentTypeBySubKeyReadonly>
                {{
                  fileInfo.documentType
                    | optionsMapping
                      : util.getSelectionOptionsBySubKey(fileInfo)
                    | replaceNullWith : '-'
                }}
              </ng-template>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'fileName'">
            <ng-container *ngIf="!editing; else fileNameInput">
              <sigv-collapsible-content-container [line]="1">
                <ng-template pTemplate="content">
                  <a
                    sigvVisitedLink
                    class="link"
                    (click)="downloadFile(fileInfo)"
                  >
                    <div style="word-break: break-all">
                      {{ getDisplayFileName(fileInfo) | replaceNullWith : '-' }}
                    </div>
                  </a>
                </ng-template>
              </sigv-collapsible-content-container>
            </ng-container>
            <ng-template #fileNameInput>
              <input
                pInputText
                [(ngModel)]="fileInfo.fileName"
                (ngModelChange)="onFileInfoChange(fileInfo)"
                [required]="true"
              />
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'uploadTime'">
            {{
              fileInfo.uploadTime
                | date : envConfig.format.datetime
                | replaceNullWith : '-'
            }}
          </ng-container>
          <ng-container *ngSwitchCase="'fileSize'">
            {{ fileInfo.fileSize | fileSize | replaceNullWith : '-' }}
          </ng-container>
          <ng-container *ngSwitchCase="'description'">
            <ng-container *ngIf="!editing; else fileDescInput">
              <sigv-collapsible-content-container [line]="1">
                <ng-template pTemplate="content">
                  <div style="word-break: break-all">
                    {{ fileInfo.description | replaceNullWith : '-' }}
                  </div>
                </ng-template>
              </sigv-collapsible-content-container>
            </ng-container>
            <ng-template #fileDescInput>
              <input
                pInputText
                [(ngModel)]="fileInfo.description"
                maxlength="100"
                (ngModelChange)="onFileInfoChange(fileInfo)"
              />
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'processor'">
            <ng-container *ngIf="!usePipeline">
              {{
                (!fileInfo.editor ? fileInfo.creator : fileInfo.editor)
                  | replaceNullWith : '-'
              }}{{ userName }}
            </ng-container>
            <ng-container *ngIf="usePipeline">
              {{
                (!fileInfo.editor ? fileInfo.creator : fileInfo.editor)
                  | userComposer
                  | async
                  | replaceNullWith : '-'
              }}
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ fileInfo[col.field] }}
          </ng-container>
        </td>
      </ng-container>
    </ng-template>
  </ng-template>
</sigv-data-table>
<sigv-content-dialog
  [(visible)]="showDialog"
  header="{{ 'File Upload' | translate }}"
  (confirm)="onUploadDialogConfirm()"
  (cancel)="onUploadDialogCancel()"
>
  <p-table [value]="tmpUploadFiles" dataKey="code">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 120px">{{ 'IMG' | translate }}</th>
        <th *ngIf="useInCase && showDocumentType" style="width: 240px">
          {{ 'File Type' | translate }}
        </th>
        <th>{{ 'File Name' | translate }}</th>
        <th>{{ 'File Size' | translate }}</th>
        <th>{{ 'File Description' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-fileInfo let-rowIndex="rowIndex">
      <tr>
        <td>
          <i
            *ngIf="checkIsShowFileTypeIcon(fileInfo); else showTmpUnknow"
            [ngClass]="getFileTypeIconStyleClassName(fileInfo)"
          ></i>
          <ng-template #showTmpUnknow>
            <i
              *ngIf="!checkIsPhoto(fileInfo); else showTmpImage"
              class="icon-unknow"
            ></i>
          </ng-template>
          <ng-template #showTmpImage>
            <img
              [src]="fileInfo.url | imageUrl | async"
              alt="photo"
              style="max-width: 60px; max-height: 60px"
            />
          </ng-template>
        </td>
        <td *ngIf="useInCase && showDocumentType">
          <p-dropdown
            sigvDropdownSetting
            [options]="pageData.selectLists.documentTypeOptions"
            [(ngModel)]="fileInfo.documentType"
            panelStyleClass="table-dropdown"
            appendTo="body"
            [style]="{ width: '100%' }"
            (ngModelChange)="onFileInfoChange(fileInfo)"
          >
            <ng-template pTemplate="item" let-item>
              {{ item.label | translate }}
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              {{ item.label | translate }}
            </ng-template>
          </p-dropdown>
        </td>
        <td>
          <input
            pInputText
            [(ngModel)]="fileInfo.fileName"
            (ngModelChange)="onFileInfoChange(fileInfo)"
          />
        </td>
        <td>{{ fileInfo.fileSize | fileSize | replaceNullWith : '-' }}</td>
        <td>
          <input
            pInputText
            type="text"
            placeholder="Here to leave your notes..."
            [(ngModel)]="fileInfo.description"
            maxlength="100"
            [required]="true"
          />
        </td>
      </tr>
    </ng-template>
  </p-table>
</sigv-content-dialog>

<p-galleria
  *ngIf="displayImages.length > 0"
  [value]="displayImages"
  [(visible)]="showGalleria"
  [responsiveOptions]="responsiveOptions"
  [containerStyle]="{ 'max-width': '50%' }"
  [numVisible]="9"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [baseZIndex]="100000"
  [showThumbnailNavigators]="false"
  [activeIndex]="currentDisplayImgIdx"
>
  <ng-template pTemplate="item" let-item>
    <img
      [src]="item.previewImageSrc | imageUrl | async"
      style="max-width: 100%; display: block; max-height: 60vh"
      alt="item"
    />
  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <div class="p-grid p-nogutter p-justify-center">
      <img
        [src]="item.thumbnailImageSrc | imageUrl | async"
        style="width: 90%; display: block"
        alt="thumbnailImageSrc"
      />
    </div>
  </ng-template>
</p-galleria>
